(function () {
    'use strict';

    angular
        .module('app')
        .controller('ShowTestMergeResult', ShowTestMergeResult);

    ShowTestMergeResult.$inject = ['DialogInstance', 'mergeResult', 'format'];

    /**
     * @ngdoc controller
     * @name ShowTestMergeResult
     *
     * @description
     * Dialog for showing the results of a test merge.
     * Currently Html and Text results are supported.
     *
     * @param {string} mergeResult - The merge result
     * @param {string} format - Format of the merge result. ('html' or 'txt')
     */
    function ShowTestMergeResult(DialogInstance, mergeResult, format) {
        /* jshint validthis:true */
        var vm = this;
        vm.mergeResult = mergeResult;
        vm.format = format;
        vm.close = close;

        activate();

        function activate() {
        }

        function close() {
            DialogInstance.ok();
        }
    }
})();
